import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn phạm vi gởi tin nhắn", -1)
const _hoisted_4 = {
  key: 0,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn khu vực gởi tin", -1)
const _hoisted_6 = {
  key: 1,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn nhóm gởi tin", -1)
const _hoisted_8 = {
  key: 2,
  class: "p-field p-col-12 p-sm-4 p-md-4",
  style: {"text-align":"center"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "A3. Giới tính ", -1)
const _hoisted_10 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "nam",
  style: {"margin-right":"60px"}
}, " Nam", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "nu" }, " Nữ", -1)
const _hoisted_13 = {
  key: 3,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Chọn công dân gởi", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", {
  id: "id-note1",
  class: "p-error"
}, "* Vui lòng chọn danh sách công dân gởi", -1)
const _hoisted_16 = {
  key: 4,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", null, null, -1)
const _hoisted_18 = {
  key: 5,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Chọn phường", -1)
const _hoisted_20 = {
  key: 6,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Chọn phường", -1)
const _hoisted_22 = {
  key: 7,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Chọn tổ", -1)
const _hoisted_24 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn", -1)
const _hoisted_26 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_27 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn phạm vi gởi tin nhắn", -1)
const _hoisted_29 = {
  key: 0,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn nhóm gởi tin", -1)
const _hoisted_31 = {
  key: 1,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn khu vực gởi tin", -1)
const _hoisted_33 = {
  key: 2,
  class: "p-field p-col-12 p-sm-4 p-md-4",
  style: {"text-align":"center"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "A3. Giới tính ", -1)
const _hoisted_35 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "nam",
  style: {"margin-right":"60px"}
}, " Nam", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "nu" }, " Nữ", -1)
const _hoisted_38 = {
  key: 3,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Chọn công dân gởi", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("small", {
  id: "id-note2",
  class: "p-error"
}, "* Vui lòng chọn danh sách công dân gởi", -1)
const _hoisted_41 = {
  key: 4,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h5", null, null, -1)
const _hoisted_43 = {
  key: 5,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", null, "Chọn phường", -1)
const _hoisted_45 = {
  key: 6,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", null, "Chọn phường", -1)
const _hoisted_47 = {
  key: 7,
  class: "p-field p-col-12 p-sm-4 p-md-4"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", null, "Chọn tổ", -1)
const _hoisted_49 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_50 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề tin nhắn", -1)
const _hoisted_52 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn", -1)
const _hoisted_54 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", null, "Đính kèm hình ảnh", -1)
const _hoisted_56 = { class: "p-inputgroup" }
const _hoisted_57 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn bài viết", -1)
const _hoisted_59 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_60 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_61 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của nút", -1)
const _hoisted_63 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của nút", -1)
const _hoisted_65 = { class: "p-inputgroup" }
const _hoisted_66 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 1", -1)
const _hoisted_68 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 1", -1)
const _hoisted_70 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn", -1)
const _hoisted_72 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1)
const _hoisted_74 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_75 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của nút", -1)
const _hoisted_77 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh nút", -1)
const _hoisted_79 = { class: "p-inputgroup" }
const _hoisted_80 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 2", -1)
const _hoisted_82 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 2", -1)
const _hoisted_84 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 2", -1)
const _hoisted_86 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1)
const _hoisted_88 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_89 = { id: "loading" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", null, "Đang gởi tin nhắn, vui lòng chờ ...", -1)
const _hoisted_91 = { class: "p-field p-col-10 p-sm-10 p-md-10" }
const _hoisted_92 = { class: "card" }
const _hoisted_93 = { class: "p-field p-col-10 p-sm-10 p-md-10" }
const _hoisted_94 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-sm-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bolder","color":"red"} }, "*Chú ý: kích thước khung ảnh chính(360 x 232 pixel), kích thước hình ảnh thành phần(50 x 50 pixel)")
], -1)
const _hoisted_96 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_97 = { class: "p-field p-col p-col-12 p-md-2 p-lg-2" }
const _hoisted_98 = { class: "p-field p-col p-col-12 p-md-2 p-lg-2" }
const _hoisted_99 = { class: "p-field p-col p-col-12 p-md-2 p-lg-2" }
const _hoisted_100 = { class: "p-field p-col-4 p-sm-4 p-md-3" }
const _hoisted_101 = { enctype: "multipart/form-data" }
const _hoisted_102 = ["disabled"]
const _hoisted_103 = { class: "col-12 md:col-4" }
const _hoisted_104 = { class: "product-grid-item card" }
const _hoisted_105 = {
  class: "product-grid-item-content",
  style: {"margin":"10px"}
}
const _hoisted_106 = ["src", "onClick"]
const _hoisted_107 = {
  class: "product-name",
  style: {"font-size":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DataView = _resolveComponent("DataView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "Gởi tin nhắn thông thường" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_Dropdown, {
                  id: "kind",
                  modelValue: $setup.action,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.action) = $event)),
                  options: $setup.lsAction,
                  optionLabel: "label",
                  optionValue: "value",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.reloadOption()))
                }, null, 8, ["modelValue", "options"])
              ]),
              ($setup.action == 'location')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_Dropdown, {
                      id: "location",
                      modelValue: $setup.province,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.province) = $event)),
                      options: $setup.listProvince,
                      optionLabel: "provinceName",
                      optionValue: "provinceCode",
                      filter: true,
                      showClear: true
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true),
              ($setup.action == 'group')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_Dropdown, {
                      id: "group",
                      modelValue: $setup.idGroup,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.idGroup) = $event)),
                      options: $setup.listGroup,
                      optionLabel: "groupName",
                      optionValue: "id",
                      filter: true,
                      showClear: true
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true),
              ($setup.action == 'gender')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "nam",
                        name: "sex",
                        value: "Nam",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.gender) = $event))
                      }, null, 512), [
                        [_vModelRadio, $setup.gender]
                      ]),
                      _hoisted_11,
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "nu",
                        name: "sex",
                        value: "Nữ",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.gender) = $event))
                      }, null, 512), [
                        [_vModelRadio, $setup.gender]
                      ]),
                      _hoisted_12
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.action == 'customer')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_MultiSelect, {
                      modelValue: $setup.listIdMessage,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.listIdMessage) = $event)),
                      options: $setup.listCustomer,
                      optionLabel: "name",
                      placeholder: "Chọn công dân",
                      filter: true
                    }, null, 8, ["modelValue", "options"]),
                    _hoisted_15
                  ]))
                : _createCommentVNode("", true),
              ($setup.action == 'age')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("label", null, "Chọn phạm vi độ tuổi: " + _toDisplayString($setup.age), 1),
                    _hoisted_17,
                    _createVNode(_component_Slider, {
                      modelValue: $setup.age,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.age) = $event)),
                      range: true
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (($setup.action == 'ward'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_MultiSelect, {
                      id: "ward",
                      modelValue: $setup.ward,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.ward) = $event)),
                      options: $setup.listWard,
                      optionLabel: "wardName",
                      placeholder: "Vui lòng chọn phường ...",
                      filter: true
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true),
              (($setup.action == 'civilGroupWithSelectWard'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_Dropdown, {
                      id: "civilWithWard",
                      modelValue: $setup.ward,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.ward) = $event)),
                      options: $setup.listWard,
                      optionLabel: "wardName",
                      placeholder: "Vui lòng chọn phường ...",
                      onChange: $setup.selectWard,
                      filter: true
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              (($setup.action == 'civilGroupWithSelectWard')||($setup.action == 'civilGroup'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_MultiSelect, {
                      id: "civilGroup",
                      modelValue: $setup.civilGroup,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.civilGroup) = $event)),
                      options: $setup.listCivilGroup,
                      optionLabel: "civilGroupName",
                      placeholder: "Vui lòng chọn tổ ...",
                      filter: true
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Textarea, {
                  id: "message",
                  type: "text",
                  modelValue: $setup.message.mess,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.message.mess) = $event)),
                  style: {"height":"100px"}
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode(_component_Button, {
              label: "Gởi tin nhắn",
              icon: "pi pi-plus-circle",
              iconPos: "left",
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.doSendMessage())),
              disabled: !$setup.valid()
            }, null, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "Gởi tin đa phương tiện" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Dropdown, {
                  id: "kind2",
                  modelValue: $setup.action2,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.action2) = $event)),
                  options: $setup.lsAction,
                  optionLabel: "label",
                  optionValue: "value",
                  onChange: _cache[14] || (_cache[14] = ($event: any) => ($setup.reloadOption2()))
                }, null, 8, ["modelValue", "options"])
              ]),
              ($setup.action2 == 'group')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_Dropdown, {
                      id: "group2",
                      modelValue: $setup.idGroup2,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.idGroup2) = $event)),
                      options: $setup.listGroup,
                      optionLabel: "groupName",
                      optionValue: "id",
                      filter: true,
                      showClear: true
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true),
              ($setup.action2 == 'location')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_Dropdown, {
                      id: "location2",
                      modelValue: $setup.province2,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.province2) = $event)),
                      options: $setup.listProvince,
                      optionLabel: "provinceName",
                      optionValue: "provinceCode",
                      filter: true,
                      showClear: true
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true),
              ($setup.action2 == 'gender')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "nam2",
                        name: "sex",
                        value: "Nam",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.gender2) = $event))
                      }, null, 512), [
                        [_vModelRadio, $setup.gender2]
                      ]),
                      _hoisted_36,
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "nu2",
                        name: "sex",
                        value: "Nữ",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.gender2) = $event))
                      }, null, 512), [
                        [_vModelRadio, $setup.gender2]
                      ]),
                      _hoisted_37
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.action2 == 'customer')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_MultiSelect, {
                      modelValue: $setup.listId,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.listId) = $event)),
                      options: $setup.listCustomer,
                      optionLabel: "name",
                      placeholder: "Chọn công dân",
                      filter: true
                    }, null, 8, ["modelValue", "options"]),
                    _hoisted_40
                  ]))
                : _createCommentVNode("", true),
              ($setup.action2 == 'age')
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("label", null, "Chọn phạm vi độ tuổi: " + _toDisplayString($setup.age2), 1),
                    _hoisted_42,
                    _createVNode(_component_Slider, {
                      modelValue: $setup.age2,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.age2) = $event)),
                      range: true
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (($setup.action2 == 'ward'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode(_component_MultiSelect, {
                      id: "ward2",
                      modelValue: $setup.ward2,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.ward2) = $event)),
                      options: $setup.listWard2,
                      optionLabel: "wardName",
                      placeholder: "Vui lòng chọn phường ...",
                      filter: true
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true),
              (($setup.action2 == 'civilGroupWithSelectWard'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode(_component_Dropdown, {
                      id: "civilWithWard2",
                      modelValue: $setup.ward2,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.ward2) = $event)),
                      options: $setup.listWard2,
                      optionLabel: "wardName",
                      placeholder: "Vui lòng chọn phường ...",
                      onChange: $setup.selectWard2,
                      filter: true
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              (($setup.action2 == 'civilGroupWithSelectWard')||($setup.action2 == 'civilGroup'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode(_component_MultiSelect, {
                      id: "civilGroup2",
                      modelValue: $setup.civilGroup2,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.civilGroup2) = $event)),
                      options: $setup.listCivilGroup2,
                      optionLabel: "civilGroupName",
                      placeholder: "Vui lòng chọn tổ ...",
                      filter: true
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Panel, { header: "Thiết kế khung chính của tin nhắn" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createVNode(_component_Textarea, {
                      id: "titleMain",
                      type: "text",
                      modelValue: $setup.element1.title,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.element1.title) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_Textarea, {
                      id: "subtitleMain",
                      type: "text",
                      modelValue: $setup.element1.subtitle,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.element1.subtitle) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_Textarea, {
                        id: "imageUrlMain",
                        type: "text",
                        modelValue: $setup.element1.image_url,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.element1.image_url) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Button, {
                        label: "chọn hình",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.showListImage(1)))
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode(_component_Textarea, {
                      id: "defaultUrl",
                      type: "text",
                      modelValue: $setup.element1.url,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.element1.url) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_Accordion, {
                      multiple: true,
                      activeIndex: [0,1]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AccordionTab, { header: "Nút tin nhắn" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _hoisted_62,
                                _createVNode(_component_InputText, {
                                  id: "title1",
                                  type: "text",
                                  modelValue: $setup.element2.title,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.element2.title) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _hoisted_64,
                                _createElementVNode("div", _hoisted_65, [
                                  _createVNode(_component_InputText, {
                                    id: "imageUrl1",
                                    type: "text",
                                    modelValue: $setup.element2.image_url,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.element2.image_url) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_Button, {
                                    label: "chọn hình",
                                    onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.showListImage(2)))
                                  })
                                ])
                              ]),
                              ($setup.element2.type == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                    _hoisted_67,
                                    _createVNode(_component_InputText, {
                                      id: "defaultUrl1",
                                      type: "text",
                                      modelValue: $setup.element2.url,
                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.element2.url) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (($setup.element2.type == 2)||($setup.element2.type == 3))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                    _hoisted_69,
                                    _createVNode(_component_InputText, {
                                      id: "automessage",
                                      type: "text",
                                      modelValue: $setup.element2.payload,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.element2.payload) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.element2.type == 4)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                    _hoisted_71,
                                    _createVNode(_component_InputText, {
                                      id: "smscontent",
                                      type: "text",
                                      modelValue: $setup.payload1.content,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.payload1.content) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (($setup.element2.type == 4)||($setup.element2.type == 5))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                    _hoisted_73,
                                    _createVNode(_component_InputMask, {
                                      mask: "(9999)999999",
                                      modelValue: $setup.payload1.phone_code,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.payload1.phone_code) = $event)),
                                      placeholder: ""
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_AccordionTab, { header: "Nút điện thoại" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _hoisted_76,
                                _createVNode(_component_InputText, {
                                  id: "title2",
                                  type: "text",
                                  modelValue: $setup.element3.title,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.element3.title) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_77, [
                                _hoisted_78,
                                _createElementVNode("div", _hoisted_79, [
                                  _createVNode(_component_InputText, {
                                    id: "imageUrl2",
                                    type: "text",
                                    modelValue: $setup.element3.image_url,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.element3.image_url) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_Button, {
                                    label: "chọn hình",
                                    onClick: _cache[38] || (_cache[38] = ($event: any) => ($setup.showListImage(3)))
                                  })
                                ])
                              ]),
                              ($setup.element3.type == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                    _hoisted_81,
                                    _createVNode(_component_InputText, {
                                      id: "defaultUrl2",
                                      type: "text",
                                      modelValue: $setup.element3.url,
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.element3.url) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (($setup.element3.type == 2)||($setup.element3.type == 3))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _hoisted_83,
                                    _createVNode(_component_InputText, {
                                      id: "automessage2",
                                      type: "text",
                                      modelValue: $setup.element3.payload,
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.element3.payload) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.element3.type == 4)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                    _hoisted_85,
                                    _createVNode(_component_InputText, {
                                      id: "smscontent2",
                                      type: "text",
                                      modelValue: $setup.payload2.content,
                                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.payload2.content) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (($setup.element3.type == 4)||($setup.element3.type == 5))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                    _hoisted_87,
                                    _createVNode(_component_InputMask, {
                                      mask: "(9999)999999",
                                      modelValue: $setup.payload2.phone_code,
                                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.payload2.phone_code) = $event)),
                                      placeholder: ""
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              label: "Gởi tin nhắn",
              icon: "pi pi-plus-circle",
              iconPos: "left",
              onClick: _cache[43] || (_cache[43] = ($event: any) => ($setup.doSendMessageWithAttachment())),
              disabled: !$setup.valid2()
            }, null, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_88, [
      _createVNode(_component_Dialog, {
        header: "Gởi tin nhắn",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[44] || (_cache[44] = ($event: any) => (($setup.loadingBar) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_89, [
            _hoisted_90,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ]),
    _createElementVNode("div", _hoisted_91, [
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          _createVNode(_component_Dialog, {
            header: "Tập tin lưu trên máy chủ",
            visible: $setup.show,
            "onUpdate:visible": _cache[49] || (_cache[49] = ($event: any) => (($setup.show) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(_component_InputText, {
                    id: "find",
                    type: "text",
                    modelValue: $setup.find,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.find) = $event)),
                    onInput: _cache[46] || (_cache[46] = ($event: any) => ($setup.search($event))),
                    placeholder: "Tìm kiếm"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createVNode(_component_Button, {
                    label: "Xóa hình",
                    onClick: $setup.deleteImage,
                    icon: "pi pi-trash",
                    style: {"margin-right":"5vw"},
                    disabled: !$setup.validImageSelect()
                  }, null, 8, ["onClick", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createVNode(_component_Button, {
                    class: "p-button-outlined",
                    label: "Đính kèm hình ảnh",
                    onclick: "document.getElementById('myFile').click()",
                    icon: "pi pi-paperclip",
                    style: {"margin-right":"5vw"}
                  })
                ]),
                _createElementVNode("div", _hoisted_99, [
                  ($setup.listFileName.length > 0)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        label: "Đăng hình",
                        onClick: _cache[47] || (_cache[47] = ($event: any) => ($setup.upload())),
                        icon: "pi pi-plus-circle",
                        style: {"margin-right":"5vw"}
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("form", _hoisted_101, [
                    _createElementVNode("input", {
                      id: "myFile",
                      type: "file",
                      style: {"display":"none"},
                      accept: ".jpeg,.png,.jpg",
                      name: "files",
                      multiple: "multiple",
                      onChange: _cache[48] || (_cache[48] = ($event: any) => ($setup.fileChange($event.target.files))),
                      disabled: $setup.loadingBar
                    }, null, 40, _hoisted_102)
                  ])
                ])
              ]),
              _createVNode(_component_DataView, {
                value: $setup.listImageFull,
                layout: $setup.layout,
                paginator: true,
                rows: 20,
                sortOrder: _ctx.sortOrder,
                sortField: _ctx.sortField
              }, {
                grid: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _createVNode(_component_Card, null, {
                          content: _withCtx(() => [
                            _createElementVNode("img", {
                              class: "imageupload",
                              src: slotProps.data.link,
                              onClick: ($event: any) => ($setup.imageClick(slotProps.data.link))
                            }, null, 8, _hoisted_106),
                            _createElementVNode("div", _hoisted_107, _toDisplayString(slotProps.data.fileName), 1),
                            _createVNode(_component_Checkbox, {
                              modelValue: slotProps.data.delete,
                              "onUpdate:modelValue": ($event: any) => ((slotProps.data.delete) = $event),
                              binary: true
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["value", "layout", "sortOrder", "sortField"])
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ])
    ])
  ], 64))
}